<template>
  <component
    :is="componentType"
    class="wave-banner"
    :class="{
      'js-open-signup-popup': signupPopup
    }"
    :href="link"
    @click="onClick">
    <div class="wave-banner__inner">
      <div class="wave-banner__content">
        <slot />
      </div>
      <!-- svg is hardcoded with the necessary attributes to be able to be stretched -->
      <svg
        class="wave-banner__sprite"
        preserveAspectRatio="none"
        viewBox="0 0 1280 69"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          class="wave-banner__path"
          clip-rule="evenodd"
          d="m0 69 52-11.6067c56-12.4358 160-36.4782 268-48.08495 108-11.60671 212-11.60671 320-4.14526 108 8.29051 212 21.12381 320 22.78191 108 .829 212-9.5171 268-16.1495l52-6.63241v63.83691h-52c-56 0-160 0-268 0s-212 0-320 0-212 0-320 0-212 0-268 0z"
          fill-rule="evenodd" />
      </svg>
    </div>
  </component>
</template>

<script>
import events from "@/events";

export default {
  name: "WaveBanner",
  props: {
    link: {
      type: String,
      default: null
    },
    signupPopup: {
      type: Boolean,
      default: false
    },
    eventName: {
      type: String,
      default: "body-20200422-wave_banner"
    }
  },
  computed: {
    componentType() {
      return this.link ? "a" : "div";
    }
  },
  methods: {
    onClick() {
      events.track(this.eventName, "1-click", this.link);
    }
  }
};
</script>

<style lang="scss">
.wave-banner {
  @include font-style(h5, $color: $white);

  display: block;

  color: $white;
  text-align: center;

  &__inner {
    position: relative;

    padding: $spacing-16 0;

    background-color: $midnight4;

    @include media(min-width, m) {
      padding-top: $spacing-24;
      padding-bottom: $spacing-24;
    }
  }

  &__content {
    position: relative;
    z-index: 1;
  }

  &__sprite {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;

    display: block;
    width: 100%;
    height: 100%;
  }

  &__path {
    fill: $midnight5;
  }

  &:hover {
    color: $white;
  }
}
</style>
